module.exports = __webpack_public_path__ + "static/media/N4.d516f69e.png";